import { TLNRForm } from './models'

export const getEmptyLNRForm = (): TLNRForm => ({
  EntryId: 0,
  Created: new Date().toISOString(),
  CreatedBy: '',
  Modified: new Date().toISOString(),
  ModifiedBy: '',
  Completeness: 0,
  RequestId: 0,
  PhoneNumber: null,
  SentToCompliance: null,
  DDQSent: null,
  DDQCompleted: null,
  DDQResponded: null,
  DDQRejected: null,
  ApprovalStatusReasons: null,
  ApprovalStatus: null,
  InvestigEndDate: null,
  InvestigStartDate: null,
  ContactId: null,
  InternalApprovalStatus: null,
})
